import { Box, Grid } from '@material-ui/core'
import { InventoryStepper } from './InventoryStepper'

interface InventoryContainerProps {
  children: JSX.Element
  smallSpacer?: boolean
}

export const InventoryContainer = ({
  children,
  smallSpacer = false,
}: InventoryContainerProps): JSX.Element => {
  return (
    <Box className="inventoryContainer">
      <Box marginBottom={2} display="block">
        <InventoryStepper direction="row" />
      </Box>
      <Grid container>
        {smallSpacer ? (
          <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
            {children}
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={12} lg={9} xl={9}>
            {children}
          </Grid>
        )}
        {/* {smallSpacer ? <Grid item lg={1} /> : <Grid item lg={2} />}
        <Grid item xs={1}>
          <Box display={{ xs: 'none', lg: 'block' }}>
            <InventoryStepper direction="column" />
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  )
}
